import React from "react";

const uid = () => `h${Math.random().toString(36).slice(2, 8)}`;

/**
 * The marketing hero's abstract geometry, inlined (not a static <img>) so
 * every fill reads the live theme tokens — var(--ink)/var(--bg)/etc. An
 * <img src="…svg"> is a separate rendering context that can't see the
 * page's CSS custom properties, so a static asset with colors baked in for
 * light mode (the cutout circle in particular, tuned to blend into the
 * light cream page) shows up as a stray light shape once the page flips to
 * dark. Inlining it fixes that for good instead of needing a second,
 * hand-matched dark asset that has to be kept in sync by hand.
 */
export const HeroArt = ({ className }) => {
  const id = uid();
  return (
    <svg
      className={className}
      viewBox="0 0 480 470"
      role="img"
      aria-label="Abstract stacked geometry"
    >
      <defs>
        <pattern
          id={`${id}dots`}
          width="13"
          height="13"
          patternUnits="userSpaceOnUse"
        >
          <circle cx="3" cy="3" r="2.1" fill="var(--ink)" />
        </pattern>
        <pattern
          id={`${id}stripe`}
          width="15"
          height="15"
          patternUnits="userSpaceOnUse"
          patternTransform="rotate(45)"
        >
          <rect width="6.5" height="15" fill="var(--border)" />
        </pattern>
      </defs>
      <g stroke="var(--border)" strokeWidth="4" strokeLinejoin="round">
        <rect
          x="52"
          y="118"
          width="300"
          height="300"
          fill={`url(#${id}dots)`}
          stroke="none"
          style={{ opacity: "var(--hero-dots, 1)" }}
        />
        <circle cx="330" cy="118" r="86" fill="var(--v-violet)" />
        <path d="M96 62h150l58 58v150H96Z" fill="var(--v-blue)" />
        {/* the folded corner stays dark in both themes: --ink turns it into a light patch on dark */}
        <path d="M246 62l58 58h-58Z" fill="var(--accent-ink)" stroke="none" />
        <rect x="150" y="176" width="210" height="210" fill="var(--accent)" />
        <path
          d="M150 176h210v210Z"
          fill={`url(#${id}stripe)`}
          stroke="none"
          opacity=".22"
        />
        <rect x="150" y="176" width="210" height="210" fill="none" />
        <circle cx="255" cy="281" r="62" fill="var(--bg)" />
        <circle cx="255" cy="281" r="26" fill="var(--v-green)" />
        <g stroke="var(--ink)" strokeWidth="5" strokeLinecap="round">
          <path d="M66 336h104" />
          <path d="M46 366h124" />
          <path d="M86 396h84" />
        </g>
        <rect
          x="372"
          y="300"
          width="74"
          height="74"
          fill="var(--danger)"
          transform="rotate(12 409 337)"
        />
        <path d="M392 424l42-24 42 24-42 24Z" fill="var(--accent)" />
      </g>
    </svg>
  );
};
